import { mutationTree, actionTree } from 'typed-vuex'
import { setState } from '~/lib/utils/store'

export const namespaced = true

export const state = () => ({
  options: null
})

export const mutations = mutationTree(
  state,
  {
    setState
  }
)

export const actions = actionTree(
  { state, mutations },
  {
    getOptions({ state, commit }) {
      if (state.options) { return Promise.resolve(state.options) }

      return this.$api.engagement.getOptions()
        .then((res) => {
          commit('setState', { stateName: 'options', data: res.data.data })
          return res.data.data
        })
    },

    postOption(...args) {
      const { scholarshipId, optionId, details } = args[1]
      const data = {
        data: {
          relationships: {
            scholarship: {
              data: {
                id: scholarshipId,
                type: 'scholarship'
              }
            },
            option: {
              data: {
                id: optionId,
                type: 'noEngagementSurveyOption'
              }
            }
          }
        }
      }

      if (details) {
        // @ts-ignore
        data.data.attributes = {
          details
        }
      }

      return this.$api.engagement.postOption(data)
    }
  }
)
